import { getDayjsLocale } from '../locales';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { parseDate } from '../dates';

export default function RelativeTime({ date, during = Infinity }) {
  const { i18n } = useTranslation();
  const [displayDate, setDisplayDate] = useState(null);

  useEffect(() => {
    const day = parseDate(date).locale(getDayjsLocale(i18n.language));
    const absoluteFormatter = new Intl.DateTimeFormat(i18n.language, {
      dateStyle: 'long',
      timeStyle: 'medium',
    });
    let interval;

    const update = () => {
      const diff = day.diff(dayjs());
      setDisplayDate(Math.abs(diff) >= during ? absoluteFormatter.format(day.toDate()) : day.fromNow());
      const shouldRefresh = during > 0 && diff > -during;
      if (!shouldRefresh) clearInterval(interval);
      return shouldRefresh;
    };

    if (update()) interval = setInterval(update, 60 * 1000);
    return () => clearInterval(interval);
  }, [date, during, i18n.language]);

  return displayDate;
}
